export default __webpack_public_path__ + "static/media/tabler_building.6ae89a7f.svg";